app.controller('BrowseLayoutListProductController', ['$rootScope', '$scope', function ($rootScope, $scope) {

    $scope.filter_placeholder = "e.g. Bella";
    $scope.current_page = 1;
    $scope.page_size = $scope.list_product_page_size ? $scope.list_product_page_size : 24;
    $scope.alpha_category_choice_list = [];
    $scope.show_placeholders = false;
    $scope.option_grid_columns = 2;
    $scope.show_filter_dropdown = false;

    let currentListViewApplied = false;


    let waitingForCompletedRequest = false;

    const productModel = $scope.product_model;

    $scope.beta_category_choice_list = $rootScope.service.cache_local_server.getBetaCategoryChoiceList(productModel.base_component_id, productModel.parent_category_group_id, productModel.parent_category_id);
    $scope.beta_category_name = productModel.beta_category_name ? productModel.beta_category_name : null;

    let haveBeta = false;
    for (let i = 0; i < $scope.beta_category_choice_list.length; i++) {
        const choice = $scope.beta_category_choice_list[i];
        if (choice.id !== "all" && choice.id !== "other") {
            haveBeta = true;
            break;
        }
    }
    if (!haveBeta || $scope.beta_category_choice_list.length === 1) {
        $scope.beta_category_choice_list.length = 0;
    }

    let selectID = null;

    const navigationIDs = $scope.navigation_ids;

    const collectionProductModel = $rootScope.factory.collection_product.getModel(navigationIDs);

    function applyProductModel() {
        if (!productModel) {
            return;
        }

        const navigationStateList = $rootScope.navigation_model.state_list;
        let filterPlaceholder = "Bella";
        for (let i = navigationStateList.length - 1; i > 0; i--) {
            const indexState = navigationStateList[i];
            if (indexState.model_id === "collection_product") {
                const choice = navigationStateList[i - 1].choice;
                if (choice && choice.name) {
                    filterPlaceholder = choice.name && choice.name.indexOf(" ") >= 0 ? choice.name.substring(0, choice.name.indexOf(" ")) : choice.name;
                }
                break;
            }
        }
        $scope.filter_placeholder = "e.g. " + filterPlaceholder;
        $scope.page_size = productModel.listPageSize ? productModel.listPageSize : $scope.page_size;
    }

    applyProductModel()

    let fullChoiceList = null;
    let filteredChoiceList = null;

    $scope.onBetaCategoryClick = function () {
        currentListViewApplied = false;
    }

    $scope.collectionList = function () {
        if (!currentListViewApplied) {
            currentListViewApplied = true;
            fullChoiceList = null;
        }
        if (!productModel) {
            return [];
        }

        if (waitingForCompletedRequest) {
            if (!productModel.has_a_completed_request && fullChoiceList) {
                return filteredChoiceList;
            }
            fullChoiceList = null;
            waitingForCompletedRequest = false;
        } else if (!productModel.has_a_completed_request) {
            waitingForCompletedRequest = true;
        }
        $scope.show_placeholders = waitingForCompletedRequest;

        if (!fullChoiceList) {
            let choiceList = [];
            if (productModel.shared_products && productModel.shared_products.list) {
                choiceList = productModel.shared_products.list;
            } else {
                choiceList = productModel.choiceList();
            }
            const betaCategoryIDs = [];
            for (let i = 0; i < $scope.beta_category_choice_list.length; i++) {
                const betaCategoryChoice = $scope.beta_category_choice_list[i];
                if (betaCategoryChoice.selected) {
                    betaCategoryIDs.push(betaCategoryChoice.id);
                }
            }
            fullChoiceList = [];
            for (let i = 0; i < choiceList.length; i++) {
                const product = choiceList[i];
                const colourException = !!navigationIDs.colour_id && !!product.colour_exceptions[navigationIDs.colour_id];
                if (colourException) {
                    continue;
                }
                const styleException = !!navigationIDs.style_id && !!product.style_exceptions[navigationIDs.style_id];
                if (styleException) {
                    continue;
                }
                if (betaCategoryIDs.length) {
                    let found = false;
                    for (let j = 0; j < betaCategoryIDs.length; j++) {
                        if (product.beta_category_ids.includes(betaCategoryIDs[j])) {
                            found = true;
                            break;
                        }
                    }
                    if (!found) {
                        continue
                    }

                }
                fullChoiceList.push(product);
            }

        }

        let stateSelectID = $scope.getSelectID ? $scope.getSelectID() : null;
        stateSelectID = stateSelectID ? stateSelectID : null;

        if (stateSelectID !== selectID) {
            filteredChoiceList = null;
            selectID = stateSelectID;
        }

        filteredChoiceList = [];

        for (let i = 0; i < fullChoiceList.length; i++) {
            const product = fullChoiceList[i];
            if (!(waitingForCompletedRequest && product.is_placeholder)) {
                if ($scope.isProductFiltered && $scope.isProductFiltered(selectID, product)) {
                    continue;
                }
            }
            filteredChoiceList.push(product);
        }

        updateAlphaCategoryChoiceList();

        return filteredChoiceList;
    }

    function updateAlphaCategoryChoiceList() {
        const alphaCategoryChoiceList = [];
        if (productModel.parent_category_cache) {
            const alphaCategoryOrder = productModel.base_component_cache.alpha_category_order;
            const alphaCategory = productModel.base_component_cache.alpha_category;
            let validList = false;
            for (let i = 0; i < alphaCategoryOrder.length; i++) {
                const alphaCategoryChoiceID = alphaCategoryOrder[i];
                const alphaCategoryChoice = alphaCategory[alphaCategoryChoiceID];
                for (let choiceID in productModel.choices) {
                    const product = productModel.choices[choiceID];
                    if (product.disabled) {
                        continue;
                    }
                    if (product.alpha_category_ids.includes(alphaCategoryChoiceID)) {
                        if (!["all", "other"].includes(alphaCategoryChoiceID)) {
                            validList = true;
                        }
                        alphaCategoryChoiceList.push(JSON.parse(JSON.stringify(alphaCategoryChoice)));
                        break;
                    }
                }
            }
            if (!validList) {
                alphaCategoryChoiceList.length = 0;
            }
        }
        let didChange = alphaCategoryChoiceList.length !== $scope.alpha_category_choice_list.length;
        if (!didChange) {
            for (let i = 0; i < alphaCategoryChoiceList.length; i++) {
                if ($scope.alpha_category_choice_list[i].id !== alphaCategoryChoiceList[i].id) {
                    didChange = true;
                    break
                }
            }
        }
        if (didChange) {
            let selectedListFilter = $scope.selected_list_filter;
            let subCategoryCount = 0;
            let selectedListFilterFound = false;
            for (let i = 0; i < alphaCategoryChoiceList.length; i++) {
                const choice = alphaCategoryChoiceList[i];
                if (choice.id === selectedListFilter) {
                    selectedListFilterFound = true;
                }
                if (choice.id !== "all") {
                    subCategoryCount++;
                }
            }
            if (!selectedListFilterFound) {
                selectedListFilter = null;
            }

            if (!selectedListFilter && alphaCategoryChoiceList.length) {
                selectedListFilter = alphaCategoryChoiceList[0].id;
            }
            $scope.selected_list_filter = selectedListFilter !== "all" ? selectedListFilter : null;
            $scope.alpha_category_choice_list = alphaCategoryChoiceList;
            $scope.show_filter_dropdown = subCategoryCount > 1;
        }
    }

    $scope.getProductRouteHref = function (productID) {
        return collectionProductModel.choices[productID] ? collectionProductModel.choices[productID].href : null
    }

}]);